var _style, _path, _path2, _g, _path3, _path4, _path5, _path6, _path7, _path8, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCardQueenClubs(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 309.4 427.3",
    style: {
      enableBackground: "new 0 0 309.4 427.3"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#E6EEF4;}\n\t.st1{clip-path:url(#SVGID_00000021805599414538446310000010925474484971932079_);}\n")), /*#__PURE__*/React.createElement("g", null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M294.7,0h-280C6.6,0,0,6.6,0,14.7v398c0,8.1,6.6,14.7,14.7,14.7h280c8.1,0,14.7-6.6,14.7-14.7V14.8 C309.4,6.6,302.8,0,294.7,0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M176.8,296.5c0,18.3,5,36.6,6.8,42.4c0.3,1-0.4,1.9-1.4,1.9h-55c-1,0-1.7-0.9-1.4-1.9c1.7-5.8,6.8-24.3,6.8-42.4 c-7.3,5.3-15.7,8-24.9,8c-26.9,0-50.3-22.6-48.6-49.9c1-15.3,10.7-28.5,23.7-36.6c13.1-8.2,25.2-8.9,36-6.3 c-6.9-8.2-11.1-18.8-11.1-30.3c0-29.1,26.3-52,56.5-46.2c18.9,3.6,33.8,19.1,37,38.1c2.5,14.7-1.9,28.4-10.4,38.5 c10.9-2.7,23.1-2,36.3,6.4c12.9,8.2,22.7,21.4,23.6,36.6c1.6,27.2-21.9,49.7-48.8,49.7C192.6,304.5,183.9,301.7,176.8,296.5"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M22,51.6v44.2c0,16.2,13.2,29.5,29.5,29.5c16.2,0,29.5-13.2,29.5-29.5V51.6c0-16.2-13.2-29.5-29.5-29.5 C35.3,22.1,22,35.2,22,51.6z M66.3,51.6v44.2c0,8.1-6.6,14.7-14.7,14.7s-14.7-6.6-14.7-14.7V51.6c0-8.1,6.6-14.7,14.7-14.7 S66.3,43.5,66.3,51.6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.6,123.8c3.3,2.5,7.9,1.8,10.3-1.5c2.5-3.3,1.8-7.9-1.5-10.3L55.9,89.8c-3.3-2.5-7.9-1.8-10.3,1.5 c-2.5,3.3-1.8,7.9,1.5,10.3L76.6,123.8z"
  }))), /*#__PURE__*/React.createElement("g", null, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M289.4,370.5c0,20.3-16.5,36.8-36.8,36.8s-36.8-16.5-36.8-36.8c0-20.3,16.5-36.8,36.8-36.8S289.4,350.2,289.4,370.5z  M252.6,340.1c-16.8,0-30.4,13.6-30.4,30.4s13.6,30.4,30.4,30.4s30.4-13.6,30.4-30.4S269.4,340.1,252.6,340.1z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M277.3,363.7c0,6.5-5.7,12.4-12.8,12.4c-7.2-0.3-12.8-5.9-12.8-12.4c0-6.5,5.7-12.2,12.8-12.4 C271.6,351.5,277.3,357.2,277.3,363.7z M272.2,363.7c0-4.2-3.5-7.6-7.8-7.6c-4.3,0-7.8,3.4-7.8,7.6s3.5,7.6,7.8,7.6 C268.7,371.3,272.2,367.9,272.2,363.7z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M261.6,386.8c0,3.5-3,6.3-6.9,6.5c-3.8,0-6.9-3-6.9-6.5c0-3.5,3.1-6.5,6.9-6.5C258.5,380.4,261.6,383.3,261.6,386.8z  M257.4,386.8c0-1.4-1.2-2.6-2.6-2.6c-1.5,0-2.6,1.1-2.6,2.6s1.2,2.6,2.6,2.6C256.2,389.3,257.4,388.2,257.4,386.8z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M244.7,359.9c-1.6,0-3,1.3-3,2.8c0,1.5,1.3,2.8,3,2.8c1.7,0,3-1.2,3-2.8C247.7,361.2,246.3,359.9,244.7,359.9z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M234.8,379.9c-1.6,0-3,1.3-3,2.8s1.3,2.8,3,2.8c1.7,0,3-1.2,3-2.8S236.4,379.9,234.8,379.9z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M270.6,383.6c-1.6,0-3,1.3-3,2.8c0,1.5,1.3,2.8,3,2.8c1.7,0,3-1.2,3-2.8C273.5,384.8,272.2,383.6,270.6,383.6z"
  })), /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("circle", {
    id: "SVGID_1_",
    cx: 252.6,
    cy: 370.5,
    r: 30.4
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000098207401722812626790000014026348591198654360_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000098207401722812626790000014026348591198654360_)"
    },
    d: "M242,350.8c-0.2,3.5-3.4,6.2-7.2,6 c-3.8-0.2-6.7-3.4-6.4-6.9c0.2-3.5,3.4-6.3,7.2-6.1C239.3,344.2,242.2,347.3,242,350.8z M237.7,350.5c0.1-1.4-1-2.6-2.5-2.7 c-1.5-0.1-2.7,1-2.8,2.4s1,2.6,2.5,2.7C236.4,353,237.7,351.9,237.7,350.5z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCardQueenClubs);
export default __webpack_public_path__ + "static/media/card_queen-clubs.ed7ea72cc37d0b5779356e47f0a6f010.svg";
export { ForwardRef as ReactComponent };